import { Component, OnInit, Input } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { FactorStrategy } from 'src/app/models/factor-strategy.model';

@Component({
  selector: 'app-portfolio-models-robustness',
  templateUrl: './portfolio-models-robustness.component.html',
  styleUrls: ['./portfolio-models-robustness.component.scss']
})
export class PortfolioModelsRobustnessComponent implements OnInit {

  @Input() strategy1: FactorStrategy;
  @Input() strategy2: FactorStrategy;
  @Input() strategy3: FactorStrategy;

  @Input() inceptionDate: Date;
  @Input() lastDate: Date;

  selectedPage: string = 'rating';
  selectedTab: string = 'Performance';
  selectedTab2: string = 'returns';
  panelOpenState: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  onTabChange(event: MatTabChangeEvent) {
    switch (event.tab.textLabel) {
      case 'Performance':    this.selectedTab='Performance'; break;
      case 'Risk':           this.selectedTab='Risk'; break;
      case 'Outperformance': this.selectedTab='Outperformance'; break;
    }
  }

  onTab2Change(event: MatTabChangeEvent) {
    switch (event.tab.textLabel) {
      case 'Returns':    this.selectedTab2='returns'; break;
      case 'Volatility': this.selectedTab2='volatility'; break;
    }
  }

}
